<!--
 * @Author: Haotao
 * @Date: 2022-10-11 16:05:43-26 17:41:34
 * @LastEditors: Haotao
-->
<template>
  <div class="main has-header bg-gray">
    <mt-header fixed title="">
      <router-link to="" slot="left">
        <mt-button icon="back" @click.native="$router.back(-1)"></mt-button>
      </router-link>
    </mt-header>
    <div class="select-area">
      <div class="item-tips">
        <img src="../../assets/images/login/IconTips.png" alt="" />
        <p>用户须知：请先上传身份证照片，完成实名认证，保证个人信息真实有效，才能进行签约。</p>
      </div>
      <div class="item-wrap-top" @click="handleGotoAuth">
        <!-- <div>
          <p class="title">居民身份证认证</p>
          <p class="info">我持有中华人民共和国居民身份证</p>
        </div>
        <img
          class="icon"
          src="@assets/images/user/mainland.png"
          alt="mainland"
        /> -->
      </div>
      <div class="item-wrap-bottom" @click="handleGotoApplyUser">
        <div class="info">港澳台通行证</div>
        <!-- <div>
          <p class="title">其他身份证认证</p>
          <p class="info">
            我持有其他身份证（港澳居民来往内地通行证，台湾居民来往大陆通行证）
          </p>
        </div>
        <img class="icon" src="@assets/images/user/others.png" alt="others" /> -->
      </div>
      <span class="description" @click="handleGotoDescription">证件说明</span>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  methods: {
    handleGotoDescription() {
      this.$router.push("/user/description");
    },
    handleGotoAuth() {
      this.$router.push("/user/authentication");
    },
    handleGotoApplyUser() {
      this.$router.push("/user/applyUser");
    },
  },
};
</script>
<style lang='less' scoped>
p {
  margin: 0;
}
.select-area {
  width: 100%;
  height: 100%;
  background: url("../../assets/images/currency.png") no-repeat;
  background-size: 100% 100%;
}
.item-wrap-top {
  width: 96vw;
  height: 48vw;
  border-radius: 3.2vw;
  background-color: #ffffff;
  margin: auto;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background: url("../../assets/images/login/MainlandIdCard.png") no-repeat;
  background-size: 100% 100%;
}
.item-wrap-bottom {
  width: 96vw;
  height: 48vw;
  border-radius: 3.2vw;
  background-color: #ffffff;
  margin: auto;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background: url("../../assets/images/login/HMTIdCard.png") no-repeat;
  background-size: 100% 100%;
}
.title {
  width: 46.6667vw;
  font-size: 5.6vw;
  font-weight: bolder;
  color: black;
  margin-bottom: 1.6vw;
}
.info {
  width: 50vw;
  height: 20vw;
  line-height: 20vw;
  background: #fff;
  color: #BEBEBE;
  font-size: 6.4vw;
  font-weight: 700;
  margin-left: -30vw;
}
.icon {
  width: 26.6667vw;
  height: 26.6667vw;
}
.description {
  font-size: 2.9333vw;
  position: fixed;
  left: 50%;
  bottom: 13.3333vw;
  transform: translate(-50%);
  color: rgb(63, 51, 129);
  text-decoration: underline;
}
.item-tips {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3% 5%;
  img {
    width: 25px;
    height: 25px;
  }
  p {
    font-size: 14px;
    color: #979797;
  }
}
</style>
